import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_NameNsDescription = _resolveComponent("NameNsDescription")!
  const _component_General = _resolveComponent("General")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_AdditionalRedactions = _resolveComponent("AdditionalRedactions")!
  const _component_Labels = _resolveComponent("Labels")!
  const _component_Tabbed = _resolveComponent("Tabbed")!
  const _component_CruResource = _resolveComponent("CruResource")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$fetchState.pending)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createVNode(_component_CruResource, {
      "done-route": _ctx.doneRoute,
      mode: _ctx.mode,
      resource: _ctx.value,
      subtypes: [],
      "validation-passed": _ctx.fvFormIsValid,
      errors: _ctx.errors,
      onError: _cache[3] || (_cache[3] = e=>_ctx.errors = e),
      onFinish: _ctx.save,
      onCancel: _ctx.done
    }, {
      default: _withCtx(() => [
        (!_ctx.isView)
          ? (_openBlock(), _createBlock(_component_NameNsDescription, {
              key: 0,
              value: _ctx.value,
              mode: _ctx.mode,
              namespaced: _ctx.schema.attributes.namespaced,
              nameRequired: false,
              "register-before-hook": _ctx.registerBeforeHook
            }, null, 8, ["value", "mode", "namespaced", "register-before-hook"]))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createTextVNode()),
        _createVNode(_component_Tabbed, { "side-tabs": true }, {
          default: _withCtx(() => [
            _createVNode(_component_Tab, {
              name: "general",
              label: _ctx.t('auditPolicy.general.title'),
              weight: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_General, {
                  value: _ctx.value.spec,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.spec) = $event)),
                  mode: _ctx.mode
                }, null, 8, ["value", "mode"])
              ]),
              _: 1
            }, 8, ["label"]),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createVNode(_component_Tab, {
              name: "filters",
              label: _ctx.t('auditPolicy.filters.title'),
              weight: 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Filters, {
                  value: _ctx.value.spec,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.spec) = $event)),
                  mode: _ctx.mode
                }, null, 8, ["value", "mode"])
              ]),
              _: 1
            }, 8, ["label"]),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createVNode(_component_Tab, {
              name: "additional-redactions",
              label: _ctx.t('auditPolicy.additionalRedactions.title'),
              weight: 1
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AdditionalRedactions, {
                  value: _ctx.value.spec,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.spec) = $event)),
                  mode: _ctx.mode
                }, null, 8, ["value", "mode"])
              ]),
              _: 1
            }, 8, ["label"]),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createVNode(_component_Tab, {
              name: "labels-and-annotations",
              "label-key": "generic.labelsAndAnnotations",
              weight: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Labels, {
                  "default-container-class": "labels-and-annotations-container",
                  value: _ctx.value,
                  mode: _ctx.mode,
                  "display-side-by-side": false
                }, null, 8, ["value", "mode"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["done-route", "mode", "resource", "validation-passed", "errors", "onFinish", "onCancel"])
  ], 64))
}